import type { State } from 'state';

/**
 * Branding is exist for the page servicedesk/customer/portal/{any}.
 * But it might not be present for the custom help centers helpcenter/{id}
 * So use it with caution
 */
export const getPortalNameFromBranding = (state: State): string | undefined => {
    if (state.persisted.branding?.name) {
        return state.persisted.branding.name;
    }

    return undefined;
};
